import { render, staticRenderFns } from "./PersonalCoaching.vue?vue&type=template&id=39e0e928&scoped=true&"
import script from "./PersonalCoaching.vue?vue&type=script&lang=js&"
export * from "./PersonalCoaching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e0e928",
  null
  
)

export default component.exports